/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectSessionListQueryVariables = {|
  slateID: string
|};
export type SelectSessionListQueryResponse = {|
  +greenMachineSessionsForSlate: ?$ReadOnlyArray<?{|
    +id: string,
    +numLineups: number,
    +minSalary: number,
    +maxSalary: number,
    +playersPerLineup: ?number,
    +reportedBy: ?{|
      +username: string
    |},
    +errorReport: ?boolean,
    +errorMessage: ?string,
    +greenmachinelineupsetSet: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string
        |}
      |}>
    |},
    +slate: {|
      +gameType: {|
        +gametypelineupsetSet: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +lineupSet: {|
                +lineuprosterslotSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +order: number,
                      +amount: number,
                      +rosterSlot: {|
                        +name: string
                      |},
                      +selectable: boolean,
                    |}
                  |}>
                |}
              |}
            |}
          |}>
        |}
      |}
    |},
  |}>
|};
export type SelectSessionListQuery = {|
  variables: SelectSessionListQueryVariables,
  response: SelectSessionListQueryResponse,
|};
*/


/*
query SelectSessionListQuery(
  $slateID: ID!
) {
  greenMachineSessionsForSlate(slateId: $slateID) {
    id
    numLineups
    minSalary
    maxSalary
    playersPerLineup
    reportedBy {
      username
      id
    }
    errorReport
    errorMessage
    greenmachinelineupsetSet {
      edges {
        node {
          id
        }
      }
    }
    slate {
      gameType {
        gametypelineupsetSet {
          edges {
            node {
              lineupSet {
                lineuprosterslotSet {
                  edges {
                    node {
                      order
                      amount
                      rosterSlot {
                        name
                        id
                      }
                      selectable
                      id
                    }
                  }
                }
                id
              }
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slateID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slateId",
    "variableName": "slateID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numLineups",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minSalary",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxSalary",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playersPerLineup",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorReport",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "GreenMachineLineupSetTypeConnection",
  "kind": "LinkedField",
  "name": "greenmachinelineupsetSet",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GreenMachineLineupSetTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GreenMachineLineupSetType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectable",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectSessionListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GreenMachineSessionType",
        "kind": "LinkedField",
        "name": "greenMachineSessionsForSlate",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserType",
            "kind": "LinkedField",
            "name": "reportedBy",
            "plural": false,
            "selections": [
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateType",
            "kind": "LinkedField",
            "name": "slate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GameTypeType",
                "kind": "LinkedField",
                "name": "gameType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GameTypeLineupSetTypeConnection",
                    "kind": "LinkedField",
                    "name": "gametypelineupsetSet",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GameTypeLineupSetTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GameTypeLineupSetType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LineupSetType",
                                "kind": "LinkedField",
                                "name": "lineupSet",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LineupRosterSlotTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "lineuprosterslotSet",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LineupRosterSlotTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LineupRosterSlotType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "RosterSlotType",
                                                "kind": "LinkedField",
                                                "name": "rosterSlot",
                                                "plural": false,
                                                "selections": [
                                                  (v13/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v14/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SelectSessionListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GreenMachineSessionType",
        "kind": "LinkedField",
        "name": "greenMachineSessionsForSlate",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserType",
            "kind": "LinkedField",
            "name": "reportedBy",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateType",
            "kind": "LinkedField",
            "name": "slate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GameTypeType",
                "kind": "LinkedField",
                "name": "gameType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GameTypeLineupSetTypeConnection",
                    "kind": "LinkedField",
                    "name": "gametypelineupsetSet",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GameTypeLineupSetTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GameTypeLineupSetType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LineupSetType",
                                "kind": "LinkedField",
                                "name": "lineupSet",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LineupRosterSlotTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "lineuprosterslotSet",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LineupRosterSlotTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LineupRosterSlotType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "RosterSlotType",
                                                "kind": "LinkedField",
                                                "name": "rosterSlot",
                                                "plural": false,
                                                "selections": [
                                                  (v13/*: any*/),
                                                  (v2/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v14/*: any*/),
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e311fc93c6b0f491f98cb24e03f7c4c9",
    "id": null,
    "metadata": {},
    "name": "SelectSessionListQuery",
    "operationKind": "query",
    "text": "query SelectSessionListQuery(\n  $slateID: ID!\n) {\n  greenMachineSessionsForSlate(slateId: $slateID) {\n    id\n    numLineups\n    minSalary\n    maxSalary\n    playersPerLineup\n    reportedBy {\n      username\n      id\n    }\n    errorReport\n    errorMessage\n    greenmachinelineupsetSet {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    slate {\n      gameType {\n        gametypelineupsetSet {\n          edges {\n            node {\n              lineupSet {\n                lineuprosterslotSet {\n                  edges {\n                    node {\n                      order\n                      amount\n                      rosterSlot {\n                        name\n                        id\n                      }\n                      selectable\n                      id\n                    }\n                  }\n                }\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'adbaae484037273026c844a7ac5903bb';

module.exports = node;
